import { MachinePartHistory } from '@/types'
import { CreateMachinePartsRequest } from '@/types/apis/machineParts/CreateMachinePartRequest'
import { CreateMachinePartResponse } from '@/types/apis/machineParts/CreateMachinePartResponse'
import { GetAllMachinePartsRequest } from '@/types/apis/machineParts/GetAllMachinePartsRequest'
import { GetAllMachinePartsResponse } from '@/types/apis/machineParts/GetAllMachinePartsResponse'
import { GetMachinePartRequest } from '@/types/apis/machineParts/GetMachinePartRequest'
import { GetMachinePartResponse } from '@/types/apis/machineParts/GetMachinePartResponse'
import { UpdateMachinePartRequest } from '@/types/apis/machineParts/UpdateMachinePartRequest'
import { UpdateMachinePartResponse } from '@/types/apis/machineParts/UpdateMachinePartResponse'
import { DeleteMachineRequest } from '@/types/apis/machines/DeleteMachineRequest'
import { DeleteMachineResponse } from '@/types/apis/machines/DeleteMachineResponse'

import axios from './axios'

const API_ENDPOINT = '/washing-machine'

export const getAllMachinePart = (request: GetAllMachinePartsRequest): Promise<GetAllMachinePartsResponse> => {
  return axios.get(`${API_ENDPOINT}/${request.id}/washing-part`)
}

export const getMachinePart = (request?: GetMachinePartRequest): Promise<GetMachinePartResponse> => {
  return axios.get(`${API_ENDPOINT}/washing-part/${request?.id}`)
}

export const createMachinePart = (request: CreateMachinePartsRequest): Promise<CreateMachinePartResponse> => {
  return axios.post(`${API_ENDPOINT}/washing-part`, request)
}

export const updateMachinePart = (request: UpdateMachinePartRequest): Promise<UpdateMachinePartResponse> => {
  return axios.put(`${API_ENDPOINT}/washing-part/${request.id}`, request)
}

export const deleteMachinePart = (request: DeleteMachineRequest): Promise<DeleteMachineResponse> => {
  return axios.delete(`${API_ENDPOINT}/washing-part/${request.id}`)
}

export const createWashingHistoryApi = (machinePartId: number): Promise<{ message: string; statusCode: number }> => {
  return axios.post(`${API_ENDPOINT}/washing-part/${machinePartId}/washing-history`)
}

export const getRecentWashingHistoryApi = (machinePartId: number): Promise<MachinePartHistory[]> => {
  return axios.get(`${API_ENDPOINT}/washing-part/${machinePartId}/recent-history`)
}
